export default __webpack_public_path__ + "static/media/token-1.98b093aa.png";